module.exports = __webpack_public_path__ + "img/img30.b669e556.svg";